import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink, withRouter } from 'react-router-dom';

class TourSidebarLink extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    new: PropTypes.bool,
    route: PropTypes.string
  };

  render () {
    return (
      <NavLink to={this.props.route ? this.props.route : '/'} onClick={this.props.onClick}
        activeClassName='sidebar__link-active' style={this.props.style}>
        <li className='sidebar__link' id={this.props.id}>
          {this.props.icon ? <span className={`sidebar__link-icon lnr lnr-${this.props.icon}`} /> : ''}
          <p className='sidebar__link-title'>
            {this.props.title}
            {this.props.new ? <Badge className='sidebar__link-badge'><span>New</span></Badge> : ''}
          </p>
        </li>
      </NavLink>
    )
  }
}

export default withRouter(TourSidebarLink);


// WEBPACK FOOTER //
// ./src/components/tour/dashboard/sidebar/TourSidebarLink.js